import { SITE_ORIGIN } from '@/config/siteOrigin';

const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/favicon.png`;

const PRODUCT_CAT_SEO = {
  detect: {
    en: {
      title: 'Detection Products | RF & Drone Monitoring | Hiray',
      description: 'Hiray RF detection and drone monitoring products for low-altitude security.',
      keywords: 'drone detection, RF detection, counter-UAS, Hiray, anti-drone'
    },
    zh: {
      title: '侦测类产品 | 无线电与无人机监测 | 汇锐',
      description: '汇锐无线电侦测、无人机监测与低空感知类产品。',
      keywords: '无人机探测, 无线电侦测, 反无人机, 汇锐, 低空安防'
    }
  },
  jamming: {
    en: {
      title: 'Jamming & Countermeasure Products | Hiray',
      description: 'Hiray jamming and electronic countermeasure systems against unauthorized drones.',
      keywords: 'drone jamming, counter-UAS, anti-drone, Hiray'
    },
    zh: {
      title: '干扰反制类产品 | 汇锐',
      description: '汇锐无人机干扰与电子反制类产品。',
      keywords: '无人机干扰, 反制, 反无人机, 汇锐'
    }
  },
  integrated: {
    en: {
      title: 'Integrated Counter-UAS Products | Hiray',
      description: 'Hiray integrated detection and counter-UAS product lines.',
      keywords: 'integrated CUAS, anti-drone system, Hiray, low-altitude security'
    },
    zh: {
      title: '侦反一体产品 | 汇锐',
      description: '汇锐侦测与反制一体化产品系列。',
      keywords: '侦反一体, 反无人机, 汇锐, 低空安防'
    }
  }
};

export const SEO_BY_ID = {
  home: {
    en: {
      title: 'Hiray | Counter-UAS & Low-Altitude Security Solutions',
      description:
        'Henan Hiray Industrial Technology Co., Ltd. — anti-drone detection, jamming, integrated counter-UAS systems and low-altitude security platforms for critical sites.',
      keywords:
        'Hiray, Henan Hiray, counter-UAS, anti-drone, low-altitude security, drone detection, CUAS'
    },
    zh: {
      title: '河南汇锐 | 反无人机与低空安防解决方案',
      description:
        '河南汇锐工业技术有限公司 — 无人机探测、干扰反制、侦反一体与低空安全管理平台，服务于要地防护与行业安防场景。',
      keywords: '河南汇锐, 汇锐, 反无人机, 低空安防, 无人机探测, CUAS, 要地防护'
    }
  },
  about: {
    en: {
      title: 'About Hiray | Industrial Counter-UAS Manufacturer',
      description: 'Company profile, qualifications and contact information for Henan Hiray Industrial Technology Co., Ltd.',
      keywords: 'Hiray company, counter-UAS manufacturer, Henan Hiray Industrial Technology'
    },
    zh: {
      title: '关于汇锐 | 工业级反无人机技术企业',
      description: '河南汇锐工业技术有限公司简介、资质与联系方式。',
      keywords: '汇锐公司, 河南汇锐, 反无人机企业, 工业技术'
    }
  },
  projects: {
    en: {
      title: 'Projects & References | Hiray Counter-UAS',
      description: 'Selected project sites and deployment references for Hiray low-altitude security solutions.'
    },
    zh: {
      title: '项目案例 | 汇锐低空安防',
      description: '汇锐反无人机与低空安防典型项目与应用案例。'
    }
  },
  products: {
    en: {
      title: 'Products | Detection, Jamming & Counter-UAS | Hiray',
      description: 'Browse Hiray product families: RF detection, jamming, physical interception, integrated counter-UAS and security platforms.',
      keywords: 'Hiray products, anti-drone products, CUAS equipment, detection, jamming'
    },
    zh: {
      title: '产品中心 | 探测、干扰与反无人机 | 汇锐',
      description: '汇锐侦测、干扰、物理拦截、侦反一体及低空安全管理平台产品系列。',
      keywords: '汇锐产品, 反无人机设备, 探测, 干扰, 低空安防'
    }
  },
  productCatalog: {
    en: { title: 'Product Catalog | Hiray', description: 'Full product catalog of Hiray counter-UAS and low-altitude security equipment.' },
    zh: { title: '产品目录 | 汇锐', description: '汇锐反无人机与低空安防产品目录。' }
  },
  productMatrix: {
    en: { title: 'Product Positioning Matrix | Hiray', description: 'Hiray product positioning matrix for counter-UAS and detection product lines.' },
    zh: { title: '产品定位矩阵 | 汇锐', description: '汇锐反无人机产品定位与系列矩阵。' }
  },
  productCapability: {
    en: { title: 'Product Capability Matrix | Hiray', description: 'Capability overview of Hiray detection, countermeasure and platform products.' },
    zh: { title: '产品能力矩阵 | 汇锐', description: '汇锐探测、反制与平台产品能力矩阵。' }
  },
  productRf: {
    en: { title: 'RF Detection System | Hiray Products', description: 'Radio-frequency drone detection and monitoring solutions by Hiray.' },
    zh: { title: '无线电侦测系统 | 汇锐产品', description: '汇锐无线电侦测与无人机监测产品。' }
  },
  productCounterB: {
    en: { title: 'Counter-UAS System | Hiray Products', description: 'Hiray counter-drone and counter-UAS product details and specifications.' },
    zh: { title: '反无人机系统 | 汇锐产品', description: '汇锐反无人机系统产品详情。' }
  },
  productIntegrated: {
    en: { title: 'Integrated Detection & Countermeasure | Hiray', description: 'All-in-one detection and counter-UAS systems from Hiray.' },
    zh: { title: '侦反一体系统 | 汇锐', description: '汇锐侦测与反制一体化产品。' }
  },
  solutionIndustry: {
    en: { title: 'Industry Solutions | Low-Altitude Security | Hiray', description: 'Industry-specific low-altitude security and anti-drone solutions from Hiray.' },
    zh: { title: '行业解决方案 | 低空安防 | 汇锐', description: '汇锐面向行业的低空安防与反无人机解决方案。' }
  },
  solutionCuas: {
    en: {
      title: 'CUAS Solution | Multi-Sensor Anti-Drone | Hiray',
      description: 'Complete CUAS solution: multi-source sensing, AI warning, linked jamming and countermeasures by Hiray.',
      keywords: 'CUAS solution, counter-UAS, anti-drone solution, Hiray'
    },
    zh: {
      title: 'CUAS 反无人机解决方案 | 汇锐',
      description: '汇锐 CUAS 体系：多源感知、智能预警、联动反制与低空安全管理。',
      keywords: 'CUAS, 反无人机解决方案, 低空安防, 汇锐'
    }
  },
  solutionCuasZh: {
    en: { title: 'CUAS Solution (CN) | Hiray', description: 'Chinese overview of Hiray integrated counter-UAS solution.' },
    zh: { title: '反无人机综合解决方案 | 汇锐', description: '汇锐反无人机综合解决方案说明。' }
  },
  solutionCuasEn: {
    en: { title: 'Integrated Counter-UAS Solution | Hiray', description: 'English overview of Hiray CUAS and low-altitude defense solution.' },
    zh: { title: 'Counter-UAS Solution | Hiray', description: 'Hiray integrated counter-UAS solution (English).' }
  },
  solutionDrone: {
    en: { title: 'Anti-Drone Defense Solutions | Hiray', description: 'Hiray anti-drone defense and perimeter protection solutions.' },
    zh: { title: '反无人机防护方案 | 汇锐', description: '汇锐反无人机防护与要地方案。' }
  }
};

function isEnglishRoute(route) {
  return route && route.query && route.query.lang !== 'zh';
}

function upsertMeta(attr, key, content) {
  if (!content || typeof document === 'undefined') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href, hreflang) {
  if (!href || typeof document === 'undefined') return;
  const selector = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function buildAbsoluteUrl(route) {
  const path = route.path || '/';
  const q = { ...route.query };
  if (isEnglishRoute(route)) {
    q.lang = 'en';
  } else {
    delete q.lang;
    if (route.query && route.query.lang === 'zh') q.lang = 'zh';
  }
  const qs = Object.keys(q)
    .filter(k => q[k] != null && q[k] !== '')
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(q[k])}`)
    .join('&');
  return `${SITE_ORIGIN}${path}${qs ? `?${qs}` : ''}`;
}

function alternateQuery(route, lang) {
  const q = { ...route.query };
  if (lang === 'en') q.lang = 'en';
  else if (lang === 'zh') q.lang = 'zh';
  else delete q.lang;
  return q;
}

function hrefForRoute(route, lang) {
  const path = route.path || '/';
  const q = alternateQuery(route, lang);
  const qs = new URLSearchParams(q).toString();
  return `${SITE_ORIGIN}${path}${qs ? `?${qs}` : ''}`;
}

function resolveSeoPack(route) {
  const seoId = (route.meta && route.meta.seoId) || 'home';
  const langKey = isEnglishRoute(route) ? 'en' : 'zh';
  let pack = (SEO_BY_ID[seoId] && SEO_BY_ID[seoId][langKey]) || SEO_BY_ID.home.en;
  if (seoId === 'products' && route.query && route.query.cat) {
    const catPack = PRODUCT_CAT_SEO[route.query.cat];
    if (catPack && catPack[langKey]) pack = catPack[langKey];
  }
  return { pack, langKey, seoId };
}

export function applyRouteSeo(route) {
  if (!route || typeof document === 'undefined') return;
  const { pack, langKey } = resolveSeoPack(route);

  document.title = pack.title;
  document.documentElement.lang = langKey === 'en' ? 'en' : 'zh-CN';

  upsertMeta('name', 'description', pack.description);
  if (pack.keywords) upsertMeta('name', 'keywords', pack.keywords);
  upsertMeta('property', 'og:title', pack.title);
  upsertMeta('property', 'og:description', pack.description);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:image', DEFAULT_OG_IMAGE);
  upsertMeta('property', 'og:locale', langKey === 'en' ? 'en_US' : 'zh_CN');
  upsertMeta('property', 'og:locale:alternate', langKey === 'en' ? 'zh_CN' : 'en_US');

  const canonical = buildAbsoluteUrl(route);
  upsertMeta('property', 'og:url', canonical);
  upsertLink('canonical', canonical);

  const enHref = hrefForRoute(route, 'en');
  const zhHref = hrefForRoute(route, 'zh');
  upsertLink('alternate', enHref, 'en');
  upsertLink('alternate', zhHref, 'zh-CN');
  upsertLink('alternate', enHref, 'x-default');

  applyRouteWebPageJsonLd(route, pack, langKey, canonical);
}

function applyRouteWebPageJsonLd(route, pack, langKey, canonical) {
  const id = 'hiray-webpage-jsonld';
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  const seoId = (route.meta && route.meta.seoId) || 'home';
  const schemaType =
    seoId.startsWith('product') && seoId !== 'products' ? 'Product' : 'WebPage';
  const base = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: pack.title,
    description: pack.description,
    url: canonical,
    inLanguage: langKey === 'en' ? 'en' : 'zh-CN',
    isPartOf: { '@id': `${SITE_ORIGIN}/#website` }
  };
  if (schemaType === 'Product') {
    base.brand = { '@type': 'Brand', name: 'Hiray' };
    base.manufacturer = { '@id': `${SITE_ORIGIN}/#organization` };
  }
  el.text = JSON.stringify(base);
}

export function injectOrganizationJsonLd() {
  if (typeof document === 'undefined') return;
  const id = 'hiray-global-jsonld';
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.id = id;
  script.type = 'application/ld+json';
  script.text = JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_ORIGIN}/#organization`,
        name: 'Henan Hiray Industrial Technology Co., Ltd.',
        alternateName: ['河南汇锐工业技术有限公司', 'Hiray', '汇锐'],
        url: SITE_ORIGIN,
        logo: `${SITE_ORIGIN}/favicon.png`,
        description: SEO_BY_ID.home.en.description,
        sameAs: [SITE_ORIGIN]
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        name: 'Henan Hiray Industrial Technology Co., Ltd.',
        alternateName: '河南汇锐工业技术有限公司',
        url: SITE_ORIGIN,
        inLanguage: ['en', 'zh-CN'],
        publisher: { '@id': `${SITE_ORIGIN}/#organization` }
      }
    ]
  });
  document.head.appendChild(script);
}
